<div class="filter-selector-wrapper">

  <!-- main layers button -->
  <div
    (click)="toggleVisibility()"
    class="layers__button noselect mat-elevation-z2"
    [ngStyle]="baseMapTypeBackground(BaseMapType.WINTER)"
  >
    <mat-icon>layers</mat-icon>
    <span>Layers</span>
  </div>


  <!-- layers list -->
  @if (switcherOpen) {
    <div class="layers__box mat-elevation-z2">

      <div class="layers__buttons">

        @for (baseMap of this.baseMaps; track baseMap) {
          <div class="map__filter__wrapper">
            <div
              [ngClass]="{ selected: baseMapLayerType === baseMap }"
              class="map__filter__square noselect"
              [ngStyle]="baseMapTypeBackground(baseMap)"
              (click)="switchBaseMap(baseMap)"
            ></div>
            <div class="map__filter__text">
              {{ baseMap === BaseMapType.DARK ? 'Night' : baseMap }}
            </div>
          </div>
        }

        @for (layer of this.customBaseMapLayers; track layer) {
          <div class="map__filter__wrapper">
            <div
              [ngClass]="{ selected: baseMapLayerType === BaseMapType.CUSTOM && customBaseMapLayerId === layer.name }"
              class="map__filter__square noselect no__background"
              (click)="switchToCustomBaseMap(layer)"
            >
              <mat-icon>layers</mat-icon>
            </div>
            <div class="map__filter__text">
              {{ layer.name }}
            </div>
          </div>
        }

      </div>

    </div>
  }
</div>
